/**
 * Strips the router basepath (/app) from a pathname.
 * This is needed because window.location.pathname includes the full path (e.g., /app/products/123)
 * but TanStack Router expects paths relative to the basepath (e.g., /products/123).
 *
 * Used for code that runs outside React context (e.g., authFlowMarker.ts).
 * For React components, prefer using TanStack Router's useRouterState hook instead.
 *
 * @param pathname - The full pathname from window.location.pathname
 * @returns The pathname without the basepath prefix
 */
export function stripBasepath(pathname: string): string {
    const basepath = '/app'

    if (pathname.startsWith(basepath)) {
        // Return the path without the basepath, or '/' if it's exactly the basepath
        const pathAfterBasepath = pathname.slice(basepath.length) || '/'
        return pathAfterBasepath
    }

    return pathname
}
